<template>
  <div class="content_menu clearfix">
    <div class="left" style="width:343px">
      <div class="left" style="width:178px;">
        <TheFoodMenu active="sandwiches" />
      </div>

      <div class="left" style="margin:0px 0 0 37px;">
        <img src="/assets/images/titles/menu_left_sandwiches.png">
      </div>

      <br clear="all">

      <div class="left" style="margin:-10px 0 0 25px;">
        <img src="/assets/images/menu_img/menu_img1.png">
      </div>
    </div>

    <div class="right" style="width:552px; margin:8px 0px 0 0;">
      <div class="product-container">
        <ProductList :products="products" />
      </div>

      <div class="menu_right" style="height:632px;">
        <div class="right" style="margin:0 14px 0 0;">
          <img src="/assets/images/menu_img/menu_right_sandwiches.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheFoodMenu from '@/components/TheFoodMenu.vue';
import ProductList from '@/components/ProductList.vue';

export default {
  name: 'Sandwiches',

  components: {
    TheFoodMenu,
    ProductList,
  },

  data() {
    return {
      products: [
        {
          id: 1,
          name: 'GARLIC HERB CHICKEN BREAST',
          description: 'Skinless chicken breast on a French roll with mayo, lettuce & tomato',
          modifiers: [],
        },
        {
          id: 2,
          name: 'TERIYAKI CHICKEN BREAST',
          description: 'Boneless, skinless teriyaki chicken breast on a French roll with mayo, lettuce and tomato',
          modifiers: [],
        },
        {
          id: 3,
          name: 'CAESAR STEAK SANDWICH',
          description: '1/2 lb. choice rib-eye steak served on a French roll with Caesar dressing, mayo, crisp romaine lettuce and tomato',
          modifiers: [],
        },
        {
          id: 4,
          breadChoices: true,
        },
        {
          id: 5,
          name: 'GRILLED CHEESE',
          description: 'Traditionally served with American cheese\nUpon request: cheddar, jack, pepper jack, or swiss',
          modifiers: [],
        },
        {
          id: 6,
          name: 'TUNA MELT',
          description: 'Tuna and mayo salad with American cheese\nUpon request: cheddar, jack, pepper jack, or swiss',
          modifiers: [],
        },
        {
          id: 7,
          name: 'HAM MELT',
          description: 'Smoked carving ham with American cheese\nUpon request: cheddar, jack, pepper jack, or swiss',
          modifiers: [],
        },
        {
          id: 8,
          name: 'TURKEY MELT',
          description: 'Oven roasted turkey breast with American cheese\nUpon request: cheddar, jack, pepper jack, or swiss',
          modifiers: [],
        },
        {
          id: 9,
          name: 'BLT',
          description: 'Bacon, lettuce, tomato and mayo\nToasted bread',
          modifiers: [],
        },
        {
          id: 10,
          name: 'CLUB',
          description: 'Double decker with ham, turkey, bacon, lettuce, tomato and mayo',
          modifiers: [],
        },
      ],
    };
  },
};
</script>
